__turbopack_context__.v({
  "accent": "SplitButton-module__Z8VzpG__accent",
  "chevronBtn": "SplitButton-module__Z8VzpG__chevronBtn",
  "disabled": "SplitButton-module__Z8VzpG__disabled",
  "fullWidth": "SplitButton-module__Z8VzpG__fullWidth",
  "icon": "SplitButton-module__Z8VzpG__icon",
  "item": "SplitButton-module__Z8VzpG__item",
  "itemDestructive": "SplitButton-module__Z8VzpG__itemDestructive",
  "itemIcon": "SplitButton-module__Z8VzpG__itemIcon",
  "lg": "SplitButton-module__Z8VzpG__lg",
  "mainBtn": "SplitButton-module__Z8VzpG__mainBtn",
  "md": "SplitButton-module__Z8VzpG__md",
  "popup": "SplitButton-module__Z8VzpG__popup",
  "positioner": "SplitButton-module__Z8VzpG__positioner",
  "primary": "SplitButton-module__Z8VzpG__primary",
  "root": "SplitButton-module__Z8VzpG__root",
  "secondary": "SplitButton-module__Z8VzpG__secondary",
  "sm": "SplitButton-module__Z8VzpG__sm",
});
